import { render, staticRenderFns } from "./pass-dialog.vue?vue&type=template&id=4c61b389"
import script from "./pass-dialog.vue?vue&type=script&lang=js"
export * from "./pass-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports